import { makeStyles } from '@material-ui/styles'

export const SparePartImagesDesktopStyles = makeStyles((theme) => ({
	root: {
		maxWidth: theme.views.maxWidth,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '10px',
		overflowY: 'auto',
		maxHeight: `calc(100vh - ${85}px)`
	},
	paperSearch: {
		padding: '20px',
		overflowY: 'auto',
		'& .MuiFormLabel-root': {
			color: theme.palette.text.primary
		}
	},
	textExpanded: {
		color: theme.palette.colors.purple
	},
	rootList: {},
	avatar: {
		width: 40,
		height: 40,
		borderRadius: 8
	},
	textSectionTitle: {
		fontWeight: 'bold', // Título en negrita
		fontSize: '1.1rem', // Tamaño de fuente un poco mayor
		color: theme.palette.colors.purple,
		marginLeft: '1rem'
	},
	sectionTitle: {
		borderRadius: '8px'
	},
	imagesSection: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '1rem'
	}
}))
